import './trainingnotes.css'

import {
	IonIcon,
	IonTextarea,
} from '@ionic/react'
import { lockClosed } from 'ionicons/icons'
import React from 'react'

type TrainingNotesProps = {
	canEdit: boolean
	noteDraft: string
	noteCharLimit: number
	onNoteInput: (value: string) => void
	onBlurSave: () => void
}

const TrainingNotes = (props: TrainingNotesProps) => {
	const { canEdit, noteDraft, noteCharLimit, onNoteInput, onBlurSave } = props

	if (!canEdit) {
		return (
			<div className="training-notes-private">
				<IonIcon icon={lockClosed} />
				<div>Team Notes are private.</div>
			</div>
		)
	}

	return (
		<div className="training-notes">
			<div className="training-notes-header">
				<div>Team Notes</div>
				<div className="training-notes-count">
					{noteDraft.length.toLocaleString()}/{noteCharLimit.toLocaleString()}
				</div>
			</div>
			<IonTextarea
				value={noteDraft}
				placeholder="Jot down any coaching notes here..."
				autoGrow={true}
				rows={8}
				maxlength={noteCharLimit}
				onIonInput={e => onNoteInput(String(e.detail.value || ''))}
				onIonBlur={() => onBlurSave()}
			/>
			<p className="training-notes-footer">
				Your notes are private and not visible to players. They can
				be viewed by any team co-coaches or club admin.
			</p>
		</div>
	)
}

export default TrainingNotes
